import { Link } from "wouter";
import AccountActions from "@/components/AccountActions";
import BrandLockup from "@/components/BrandLockup";
import FlightPath from "@/components/FlightPath";
import { useAuth } from "@/contexts/AuthContext";

export default function Home() {
  const { session, isLoading } = useAuth();

  return (
    <div className="paper-shell">
      <header className="site-header">
        <BrandLockup />
        <FlightPath className="header-flight-path" />
      </header>

      <main className="welcome-layout">
        <section className="welcome-copy" aria-labelledby="welcome-title">
          <p className="eyebrow"><span className="eyebrow-rule" /> A guided journal</p>
          <h1 id="welcome-title">Home,<br />Twice<span className="title-period">.</span></h1>
          <p className="subtitle">My life abroad</p>
          <p className="welcome-description">
            Your printed journal holds 11 voice pages. Sign in to record an answer
            and share it with family.
          </p>
          <p className="gentle-note">Take your time. There’s no wrong answer.</p>
          {isLoading ? (
            <span className="primary-action" role="status" aria-live="polite">Checking your sign-in…</span>
          ) : session ? (
            <Link href="/library" className="primary-action">
              Go to my voice pages <span aria-hidden="true">→</span>
            </Link>
          ) : (
            <Link href="/login" className="primary-action">
              Sign in <span aria-hidden="true">→</span>
            </Link>
          )}
        </section>

        <aside className="journal-art" aria-label="An illustration of an open journal and a path home">
          <div className="journal-book" aria-hidden="true">
            <div className="book-spine" />
            <div className="book-page book-page-left">
              <span className="page-line page-line-short" />
              <span className="page-line" />
              <span className="page-line page-line-short" />
              <span className="page-number">05</span>
            </div>
            <div className="book-page book-page-right">
              <svg className="page-flower" viewBox="0 0 48 48" fill="none" aria-hidden="true">
                <path d="M24 4.75v11.5m0 15.5v11.5M4.75 24h11.5m15.5 0h11.5M10.4 10.4l8.1 8.1m11 11 8.1 8.1M37.6 10.4l-8.1 8.1m-11 11-8.1 8.1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                <circle cx="24" cy="24" r="4.5" stroke="currentColor" strokeWidth="1.5" />
              </svg>
              <span className="page-line" />
              <span className="page-line page-line-short" />
              <span className="page-line" />
            </div>
          </div>
          <svg className="flight-path" viewBox="0 0 280 176" fill="none" aria-hidden="true">
            <path d="M11 143C65 151 67 73 126 80C174 86 158 23 229 31" stroke="currentColor" strokeWidth="1.5" strokeDasharray="3 7" />
            <circle cx="12" cy="143" r="5" fill="currentColor" />
            <circle cx="229" cy="31" r="5" fill="currentColor" />
            <path d="M240 27L254 19L251 34L247 29L242 33L244 28L240 27Z" fill="currentColor" />
          </svg>
          <div className="art-page-count"><span>11</span> voice pages</div>
        </aside>
      </main>

      {session && <div className="home-account-layout"><AccountActions placement="library" /></div>}

      <footer className="site-footer legal-home-footer">
        <span>Home, Twice</span>
        <nav className="legal-footer-links" aria-label="Legal">
          <Link href="/privacy">Privacy Policy</Link>
          <Link href="/terms">Terms</Link>
        </nav>
        <span>Published by Kwaderno &amp; Co.</span>
      </footer>
    </div>
  );
}
